/* eslint-disable import/prefer-default-export */
/* eslint-disable no-unused-expressions */
/* eslint-disable func-names */
/* eslint-disable prefer-rest-params */
export function initFreshchat() {
  const widgetId = process.env.REACT_APP_FRESH_DESK_STAFF_WIDGET_ID;
  const token = process.env.REACT_APP_FRESHCHAT_TOKEN;
  const schoolId = process.env.REACT_APP_SCHOOL_ID;
  const isEP = process.env.REACT_APP_ENRICHMENT_PLATFORM === 'true';

  if (
    window.location.href.includes('staff') ||
    window.location.href.includes('admin-ep')
  ) {
    window.fwSettings = { widget_id: widgetId };

    !(function () {
      if (typeof window.FreshworksWidget !== 'function') {
        const n = function () {
          n.q.push(arguments);
        };
        n.q = [];
        window.FreshworksWidget = n;
      }
    })();

    const tag = document.createElement('script');
    tag.src = `https://widget.freshworks.com/widgets/${widgetId}.js`;
    tag.async = true;
    tag.defer = true;
    document.body.appendChild(tag);
  } else {
    window.onload = function () {
      if (window.fcWidget && !window.fcWidget.isInitialized()) {
        const config = {
          token,
          host: 'https://wchat.freshchat.com',
          config: {
            cssNames: {
              widget: 'fc_frame',
            },
          },
        };

        if (window.location.href.includes('/pss/')) {
          const fcFrame = document.getElementById('fc_frame');
          if (fcFrame?.style) fcFrame.style.display = 'none';
        }

        if (window.location.href.includes('chat')) {
          config.open = true;
        }

        if (schoolId === '1') {
          const tags = isEP ? ['mfs_ep'] : ['mfs'];
          config.faqTags = { tags, filterType: 'category' };
        } else {
          config.config = {
            content: {
              actions: { tab_faq: 'Troubleshoot' },
              headers: {
                faq: 'Troubleshoot',
                faq_help: 'Browse through articles for help',
              },
            },
          };
        }

        window.fcWidget.init(config);
      } else {
        window.fcWidget.init({
          token,
          host: 'https://wchat.freshchat.com',
          config: {
            content: {
              actions: { tab_faq: 'Troubleshoot' },
              headers: {
                faq: 'Troubleshoot',
                faq_help: 'Browse through articles for help',
              },
            },
          },
        });
      }
    };
  }
}
